module.exports = __webpack_public_path__ + "static/assets/c415b2f08388371457fff1548f530a6b.svg";